import React from "react"
import { Link } from "gatsby"
import Image from "gatsby-image"

import { rhythm, scale } from "../../utils/typography"
import styled from 'styled-components'

const ArticleTag = styled.article`
  margin-top: 80px;
  padding-left: 24px;
  border-left: solid 16px rgba(0, 0, 0, 0.1);
  width: 100%;
  display: flex;
  @media(max-width: 780px) {
    display: block;
  }
  div.img-wrapper {
    width: 50%;
    margin-left: 24px;
    border-bottom: dashed 1px gray;
    @media(max-width: 780px) {
      margin-left: 0px;
      margin-top: 16px;
      border-bottom: none;
    }
  }
  div.ctx-wrapper {
    width: 100%;
    header {
      h3 {
        margin-top: 0px;
        text-decoration: underline;
        &:hover {
          color: orange!important;
        }
        a {
          line-height: 40px;
          margin-top: -8px;
        }
      }
    }
  }
`
const TagsSpan = styled.span`
  font-weight: bold;
  color: orange;
  a {
    margin-left: 8px;
    color: orange;
    box-shadow: none;
    &:hover {
      text-decoration: underline;
    }
  }
`

const Article = ({ node, title, thumbnailFluid }) => {
  return (
    <ArticleTag key={node.fields.slug}>
      <div className="ctx-wrapper">
        <header>
          <h3
            style={{
              marginBottom: rhythm(1 / 4),
            }}
          >
            <Link style={{ boxShadow: `none` }} to={node.fields.slug}>
              {title}
            </Link>
          </h3>
          <p
            style={{
              ...scale(-1 / 5),
              display: `block`,
              marginBottom: 0,
              fontSize: 11
              // marginBottom: rhythm(1),
            }}
          >
            {node.frontmatter.date}
          </p>
        </header>
        <section>
          <p
            style={{
              marginTop: 24,
              marginBottom: 24
            }}
            dangerouslySetInnerHTML={{
              __html: node.frontmatter.description || node.excerpt,
            }}
          />
          <TagsSpan style={{ display: !node.frontmatter.tags && 'none' }}>#
            { node.frontmatter.tags && node.frontmatter.tags.map(tag => {
                return <Link key={tag} to={`/tag/${tag}/`}>{tag}</Link>
              })
            }
          </TagsSpan>
        </section>
      </div>
      { thumbnailFluid && (
        <div className="img-wrapper">
          <Image fluid={thumbnailFluid} />
        </div>
      )}
    </ArticleTag>
  )
}

export default Article
